(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact-form-with-info"]) return;
  try {
    
  function validateEmail(email) {
	    var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	    return re.test(email);
	  }
	  
  function validate() {
  if($("#ContactFormEmail").val()){
    var $result = $("#result");
    var email = $("#ContactFormEmail").val();
    $result.text(""); 

    if (!validateEmail(email)) {
      $result.text("Email is not valid");
      $result.css({"color":"red", "display": "block" });
      return false;
    }
  }

  }
  $(document).ready(function () {
    $("#shopify-section-contact-form-with-info #contact_form button").bind("click", validate);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["text-image-animated-banner"]) return;
  try {
    

$(document).ready(function () {
   $(".text_image_banner_inner:first-child img.zoomIn").addClass("animatein");
});
$(window).scroll(function () {
  $(".text_image_banner_inner img.zoomIn").each(function(){
    if (isInViewportsdata($(this))){
		$(this).addClass("animatein");
    }
  }); 
  $(".text_image_banner_inner img.zoomOut").each(function(){
    if (isInViewportsdata($(this))){
		$(this).addClass("animateout");
    }
  }); 

});
function isInViewportsdata(elem){
   return $(elem).offset().top - $(window).scrollTop() < $(elem).height() ;
}

  } catch(e) { console.error(e); }
})();
})();
